<template>
  <!-- eslint-disable max-len -->
  <div
    style="background-image: url('static/img/bg.jpg')"
  >
    <div
      class="sb_grid"
    >
      <div class="sb_grid_container u_max-width-1000 u_padding-top-40 u_margin-top-40">
        <div class="sb_grid_column_3-4">
          <ContentHeader
            title="Dissociation tool"
            class="v_description-min-height"
          >
            <template v-slot:description>
              <div style="opacity: 0.6;">
                <p>The dissociation calculator can calculate the amount of dissociation at different pH’s.  At lower pH, organic acids become more undissociated. The undissociated form is usually by far the most effective in inhibiting microorganisms.  The more undissociated acid is present, the more potent is the antimicrobial solution.</p>

                <p>
                  Not all organic acids are potent antimicrobials and an organic acid can be effective against a specific range of microorganisms (more details in FAQ).
                </p>
              </div>

              <img
                style="opacity: 1;"
                src="static/img/Acetic-acid-dissociation-3D-balls.png"
                alt=""
              >
            </template>
          </ContentHeader>
          <hr>
          <RouterLink
            to="/calculator"
            class="sb_button v_has-icon-right v_icon-faded v_brand-primary-lighter v_expand-on-small u_margin-bottom-0"
            :disabled="false"
            tag="button"
          >
            <ButtonObject icon="icon_ui_caret-right">
              Get started
            </ButtonObject>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import ContentHeader from '@/components/assemblies/content-header';

export default {
  name: 'Home',
  components: {
    ContentHeader
  },
  data() {
    return {
      showRegisterModal: false,
      email: null,
      password: null,
      loginError: null,
      loggingIn: false
    };
  },
  computed: {
    ...mapState('global', [
      'appTitle'
    ])
  },
  methods: {
    ...mapActions('auth', [
      'authenticate'
    ]),
    ...mapMutations('auth', [
      'setUser'
    ]),
    openRegisterModal() {
      this.showRegisterModal = true;
    },
    async login() {
      // this.loggingIn = true;
      // const res = await this.authenticate({
      //   email: this.email,
      //   pass: this.password
      // });
      // this.loggingIn = false;
      // if (res instanceof Array) {
      //   this.password = '';
      //   this.loginError = true;
      //   return;
      // }
      // if (res)
      this.$router.push('calculator');
    }
  }
};
</script>

<style lang="scss">

</style>
